import { Pic } from "../Pic";

const FRAMES = [
  ["/images/event-6.jpg", "Winning team holding the Trivia Nation trophy and a Game Show Loco champions poster in front of the live scoreboard"],
  ["/images/event-8.jpg", "Leadership team posing with the Trivia Nation trophy at a Brooks Rehabilitation leadership challenge"],
  ["/images/event-9.jpg", "Club members laughing at round tables in a vaulted clubhouse room during a live-hosted game"],
  ["/images/event-10.jpg", "Three friends smiling and holding the Trivia Nation trophy at a private house party"],
  ["/images/event-2.jpg", "Large corporate team group photo after a hosted game"],
  ["/images/event-11.jpg", "Three guests holding the Trivia Nation trophy on a rooftop terrace at night"],
];

export const Filmstrip = () => (
  <div data-testid="about-filmstrip" className="filmstrip relative -mx-5 mt-12 overflow-hidden sm:-mx-8 lg:mt-16">
    <div className="filmstrip-track flex w-max gap-4 px-5 sm:px-8">
      {[...FRAMES, ...FRAMES].map(([src, alt], i) => (
        <div key={i} className="w-[220px] shrink-0 overflow-hidden rounded-2xl ring-1 ring-black/10 shadow-[0_20px_40px_-24px_rgba(0,0,0,0.5)] sm:w-[280px]" aria-hidden={i >= FRAMES.length}>
          <Pic src={src} alt={i < FRAMES.length ? alt : ""} sizes="280px" priority={i < 3} className="aspect-[4/3] h-full w-full object-cover" />
        </div>
      ))}
    </div>
  </div>
);
